import { Data } from 'clarifai-web-grpc/proto/clarifai/api/resources_pb';
import { Value } from 'google-protobuf/google/protobuf/struct_pb';

export const setPartDataTypes = (data: Data, value: Value.AsObject, fieldType?: number) => {
  const stringVal = value.stringValue;
  const numVal = value.numberValue;
  if (numVal) {
    if (fieldType === 4) {
      data.setFloatValue(Number(numVal));
    } else if (fieldType === 3) {
      data.setIntValue(Number(numVal));
    }
  }
  if (stringVal) {
    if (fieldType === 4) {
      data.setFloatValue(Number(stringVal));
    } else if (fieldType === 3) {
      data.setIntValue(Number(stringVal));
    } else {
      data.setStringValue(stringVal);
    }
  }
  data.setBoolValue(value.boolValue);
};
